define("settings/components/modal/form-footer", ["exports", "@ember/component", "@ember/component/template-only", "@ember/template-factory"], function (_exports, _component, _templateOnly, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{#if (has-block)}}
    {{yield}}
  {{else}}
    <Shared::Ui::Button
      @onClick={{@cancel}}
      @variant="outline"
      class={{concat-classes "u--float--left" @cancelButtonQaClass}}
      data-test-id="cancel"
      type="button"
    >
      {{if @cancelButtonText @cancelButtonText (t "shared_words.cancel")}}
    </Shared::Ui::Button>
  
    <Shared::Ui::Button
      @isDisabled={{or @isDisabled @isRunning}}
      class={{concat-classes "u--float--right" @submitButtonQaClass}}
      data-test-id="save"
      type="submit"
    >
      {{#if (and @isRunning @runningText)}}
        {{@runningText}}
      {{else}}
        {{if @submitButtonText @submitButtonText (t "shared_words.save")}}
      {{/if}}
    </Shared::Ui::Button>
  {{/if}}
  */
  {
    "id": "TOA5qyRY",
    "block": "[[[41,[48,[30,9]],[[[1,\"  \"],[18,9,null],[1,\"\\n\"]],[]],[[[1,\"  \"],[8,[39,3],[[16,0,[28,[37,4],[\"u--float--left\",[30,1]],null]],[24,\"data-test-id\",\"cancel\"],[24,4,\"button\"]],[[\"@onClick\",\"@variant\"],[[30,2],\"outline\"]],[[\"default\"],[[[[1,\"\\n    \"],[1,[52,[30,3],[30,3],[28,[37,5],[\"shared_words.cancel\"],null]]],[1,\"\\n  \"]],[]]]]],[1,\"\\n\\n  \"],[8,[39,3],[[16,0,[28,[37,4],[\"u--float--right\",[30,4]],null]],[24,\"data-test-id\",\"save\"],[24,4,\"submit\"]],[[\"@isDisabled\"],[[28,[37,6],[[30,5],[30,6]],null]]],[[\"default\"],[[[[1,\"\\n\"],[41,[28,[37,7],[[30,6],[30,7]],null],[[[1,\"      \"],[1,[30,7]],[1,\"\\n\"]],[]],[[[1,\"      \"],[1,[52,[30,8],[30,8],[28,[37,5],[\"shared_words.save\"],null]]],[1,\"\\n\"]],[]]],[1,\"  \"]],[]]]]],[1,\"\\n\"]],[]]]],[\"@cancelButtonQaClass\",\"@cancel\",\"@cancelButtonText\",\"@submitButtonQaClass\",\"@isDisabled\",\"@isRunning\",\"@runningText\",\"@submitButtonText\",\"&default\"],false,[\"if\",\"has-block\",\"yield\",\"shared/ui/button\",\"concat-classes\",\"t\",\"or\",\"and\"]]",
    "moduleName": "settings/components/modal/form-footer.hbs",
    "isStrictMode": false
  });
  var _default = _exports.default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());
});